import './DurationSelector.scss'
import {getAnnotationId, getAssetId1, getAssetId2, getMaxDuration, setAnnotation, setDuration} from "../../ducks/comparator-duck.js";
import {useDispatch, useSelector} from "react-redux";
import dayjs from "dayjs";
import {useAnnotations} from "../../api/use-annotations-api.js";
import {getAllAssets} from "../../ducks/assets-duck.js";
import {useEffect, useRef, useState} from "react";
import ChevronDownIcon from "mdi-react/ChevronDownIcon.js";

export default () => {

    const dispatch = useDispatch()
    const selectedDuration = useSelector(getMaxDuration)
    const selectedAnnotationId = useSelector(getAnnotationId)
    const assetId1 = useSelector(getAssetId1)
    const assetId2 = useSelector(getAssetId2)
    const {annotations = []} = useAnnotations()
    const allAssets = useSelector(getAllAssets)

    const today = dayjs().format('YYYY-MM-DD')
    const filteredAnnotations = annotations
        .filter(a => a.asset_id === null || a.asset_id === assetId1 || a.asset_id === assetId2)
        .filter(a => a.date <= today)
        .sort((a, b) => dayjs(b.date).diff(dayjs(a.date)))

    const durations = [
        {days: 7, label: '1w'},
        {days: 31, label: '1m'},
        {days: (31 * 3) - 1, label: '3m'},
        {days: dayjs().dayOfYear(), label: 'ytd'},
        {days: 365, label: '1y'},
        {days: (365 * 3) + 1, label: '3y'},
        {days: (365 * 5) + 2, label: '5y'},
    ]

    const getAssetCode = assetId => allAssets?.find(a => a.id === assetId)?.code || ''

    const selectedAnnotation = filteredAnnotations.find(a => a.id === selectedAnnotationId)
    const isAnnotationActive = selectedAnnotationId !== null

    const onSelect = annotation => {
        if (!annotation) {
            dispatch(setDuration(selectedDuration))
        } else {
            dispatch(setAnnotation({id: annotation.id, startDate: annotation.date}))
        }
    }

    return (
        <div className='duration-selector'>
            {filteredAnnotations.length > 0 &&
                <EventDropdown
                    annotations={filteredAnnotations}
                    selectedAnnotation={selectedAnnotation}
                    isAnnotationActive={isAnnotationActive}
                    getAssetCode={getAssetCode}
                    onSelect={onSelect}
                />
            }
            {durations.map(duration =>
                <Duration
                    key={duration.days}
                    selectedDuration={selectedDuration}
                    isAnnotationActive={isAnnotationActive}
                    {...duration}
                />
            )}
        </div>
    )
}

const EventDropdown = ({annotations, selectedAnnotation, isAnnotationActive, getAssetCode, onSelect}) => {
    const [isOpen, setIsOpen] = useState(false)
    const ref = useRef(null)

    useEffect(() => {
        if (!isOpen) return
        const handler = e => {
            if (!ref.current?.contains(e.target)) setIsOpen(false)
        }
        document.addEventListener('mousedown', handler)
        return () => document.removeEventListener('mousedown', handler)
    }, [isOpen])

    const handleSelect = annotation => {
        onSelect(annotation)
        setIsOpen(false)
    }

    const triggerLabel = selectedAnnotation ? selectedAnnotation.text : 'Events'

    return (
        <div className='event-dropdown' ref={ref}>
            <button
                className={isAnnotationActive ? 'is-selected' : ''}
                onClick={() => setIsOpen(o => !o)}
            >
                {triggerLabel}
                <ChevronDownIcon className={`chevron ${isOpen ? 'open' : ''}`} size={14}/>
            </button>
            {isOpen &&
                <div className='event-dropdown-list'>
                    {isAnnotationActive &&
                        <div className='event-dropdown-item reset' onClick={() => handleSelect(null)}>
                            <span className='event-name'>Events</span>
                        </div>
                    }
                    {annotations.map(a => (
                        <div
                            key={a.id}
                            className={`event-dropdown-item ${a.id === selectedAnnotation?.id ? 'is-selected' : ''}`}
                            onClick={() => handleSelect(a)}
                        >
                            <span className='event-name'>
                                {a.text}{a.asset_id ? ` (${getAssetCode(a.asset_id)})` : ''}
                            </span>
                            <span className='event-date'>{dayjs(a.date).format('YYYY-MM-DD')}</span>
                        </div>
                    ))}
                </div>
            }
        </div>
    )
}

const Duration = ({label, days, selectedDuration, isAnnotationActive}) => {
    const dispatch = useDispatch()
    const isSelected = !isAnnotationActive && selectedDuration === days
    return (
        <button onClick={() => dispatch(setDuration(days))} className={isSelected ? 'is-selected' : ''}>
            {label}
        </button>
    )
}
